import { ADA_PARSEL } from "../constants/requestUrls";
import {  postRequest } from "../request";

const adaParselList = (props) => {

    let data = {};
    if (props !== undefined)
      data = JSON.stringify(props);

    return postRequest({url:ADA_PARSEL,data});
}

export default adaParselList;